export default __webpack_public_path__ + "static/media/powerladder_banner_highlight.096fdbec.png";